$(document).ready(function () {
  var $body = $('body');
  const $wrapper = $('quick-order-list');
  const $checkAll = $wrapper.find('.check-all');
  const $checkItem = $wrapper.find('input[type="checkbox"]');
  const $totalsSubtotal = $wrapper.find('.totals__subtotal-value');
  const $qty = $wrapper.find('.quantity__input');
  const $btnAdd = $wrapper.find('#quick-order-list__button');

  $checkAll.on('change', function () {
    $checkItem.prop('checked', $(this).prop('checked'));
  });

  $checkItem.on('change', function() {
    var total = subtotalCalculation();
    $totalsSubtotal.html(total);
  });

  $qty.on('change', function() {
    var total = subtotalCalculation();
    $totalsSubtotal.html(total);
  });

  $btnAdd.on('click', function() {
    let items = [];

    const $checkedItems = $wrapper.find('input[type="checkbox"]:not(.check-all):checked');

    $checkedItems.each(function () {
      const $item = $(this);
      const $qtyEl = $item.closest('.variant-item').find('.quantity__input');

      if ($qtyEl.val() > 0) {
        items.push({ id: $qtyEl.attr('data-quantity-variant-id'), quantity: $qtyEl.val() })
      }

    });

    if (!items.length) return;

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {items: items},
        dataType: 'json',
        success: function(cart) {
            console.log('Added multiple variants:', cart);

            switch (window.after_add_to_cart.type) {
                case 'cart':
                    halo.redirectTo(window.routes.cart);

                    break;
                case 'quick_cart':
                  
                  var isSidecartBlocked = localStorage.getItem('isSidecartOpen') === 'true';
                  if (!isSidecartBlocked) {
                      if(window.quick_cart.show){
                          Shopify.getCart((cart) => {
                              if( window.quick_cart.type == 'popup'){
                                  $('body').addClass('cart-dropdown-show');
                              } else {
                                  $('body').addClass('cart-sidebar-show');
                              }
    
                              const cartItems = document.querySelector('quick-cart-items');
    
                              if(cartItems) cartItems.update(cart);
                          });
                      } else {
                          halo.redirectTo(window.routes.cart);
                      }
                    }else {
                        Shopify.getCart((cart) => {
                        $body.find('[data-cart-count]').text(cart.item_count);
                          if (cart.item_count >= 100){
                              $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
                          }
                          $('.background-overlay').removeClass('hold');
                        });
                          Shopify.getCart((cart) => {
                            if(!$.isEmptyObject(cart)){
                                const cartItems = document.querySelector('cart-items');
                                if(cartItems) cartItems.update(cart);
                            }
                          });
                    }

                    break;
                case 'popup_cart_1':
                    Shopify.getCart((cart) => {
                        halo.updatePopupCart(cart, 1);
                    });

                    break;
                case 'popup_cart_2':
                    Shopify.getCart((cart) => {
                        halo.updatePopupCart(cart, 2);
                    });

                case 'nonaction':
                  Shopify.getCart((cart) => {
                      $body.find('[data-cart-count]').text(cart.item_count);
                        if (cart.item_count >= 100){
                            $body.find('.cart-count-bubble [data-cart-count]').text(window.cartStrings.item_99);
                        }
                        $('.background-overlay').removeClass('hold');
                    });
                      Shopify.getCart((cart) => {
                        if(!$.isEmptyObject(cart)){
                            const cartItems = document.querySelector('cart-items');
                            if(cartItems) cartItems.update(cart);
                        }
                      });
                    break;
            }
        },
        error: function(xhr, status, error) {
            console.error('Error:', error);
        }
    });
  });

  function subtotalCalculation() {
    const $checkedItems = $wrapper.find('input[type="checkbox"]:not(.check-all):checked');
    let total = 0;

    $checkedItems.each(function () {
      const $item = $(this);
      const $qtyEl = $item.closest('.variant-item').find('.quantity__input');

      if ($qtyEl.val() > 0) {
        const $priceEl = $item.closest('.variant-item').find('[data-price]');
        const price = parseFloat($priceEl.data('price')) || 0;
        total += price * $qtyEl.val();
      }

    });
    total = Shopify.formatMoney(total, window.money_format);
    return total;
  }
});
